import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d992e018"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "BuyDetail"
}
const _hoisted_2 = { class: "Header" }
const _hoisted_3 = { class: "peoductInfo" }
const _hoisted_4 = { class: "infoItem" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "采购品种", -1))
const _hoisted_6 = {
  class: "value",
  style: {"color":"#33ac9c","font-size":"14pt"}
}
const _hoisted_7 = { class: "infoItem" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "规格详情", -1))
const _hoisted_9 = { class: "value" }
const _hoisted_10 = { class: "infoItem" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "报价方式", -1))
const _hoisted_12 = { class: "value" }
const _hoisted_13 = { class: "infoItem" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "发布时间", -1))
const _hoisted_15 = {
  class: "value",
  style: {"color":"red"}
}
const _hoisted_16 = { class: "infoItem" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "采购地区", -1))
const _hoisted_18 = { class: "value" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "sub" }, "- 以下为您推荐会员供应信息 -"),
  /*#__PURE__*/_createElementVNode("div", { class: "des" }, "温馨提示：会员产品，质量保障")
], -1))
const _hoisted_20 = ["onClick"]
const _hoisted_21 = { class: "info" }
const _hoisted_22 = { class: "topTag" }
const _hoisted_23 = { class: "item-img" }
const _hoisted_24 = { class: "item-info" }
const _hoisted_25 = { class: "title" }
const _hoisted_26 = { class: "text" }
const _hoisted_27 = { class: "time" }
const _hoisted_28 = { class: "quantityWarpper" }
const _hoisted_29 = {
  key: 0,
  class: "quantity"
}
const _hoisted_30 = {
  key: 1,
  class: "quantity"
}
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "电议", -1))
const _hoisted_32 = [
  _hoisted_31
]
const _hoisted_33 = { class: "isBond" }
const _hoisted_34 = /*#__PURE__*/_createTextVNode("已缴纳保证金")
const _hoisted_35 = { class: "tags" }
const _hoisted_36 = /*#__PURE__*/_createTextVNode("实名认证")
const _hoisted_37 = /*#__PURE__*/_createTextVNode("企业认证")
const _hoisted_38 = { class: "address" }
const _hoisted_39 = { class: "add" }
const _hoisted_40 = { class: "distance" }
const _hoisted_41 = { class: "more" }
const _hoisted_42 = { class: "actions" }
const _hoisted_43 = /*#__PURE__*/_createTextVNode("免费报价")
const _hoisted_44 = /*#__PURE__*/_createTextVNode("打电话")
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "呼叫电话", -1))
const _hoisted_46 = { class: "telNum" }
const _hoisted_47 = { class: "btn" }
const _hoisted_48 = /*#__PURE__*/_createTextVNode("暂不拨打")
const _hoisted_49 = /*#__PURE__*/_createTextVNode("立即呼叫")
const _hoisted_50 = { class: "notFollow" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "苗搭档", -1))
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content" }, "找苗、卖苗快人一步 为了匹配更好的求购处理 请关注公众号", -1))
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tips" }, "长安二维码识别关注", -1))
const _hoisted_54 = { class: "notFollow" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title1" }, "温馨提示", -1))
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content1" }, "尊敬的用户，查看信息、免费报价、查看电话等都需要实名认证，请尽快进行身份信息认证！", -1))
const _hoisted_57 = { class: "btn1" }
const _hoisted_58 = /*#__PURE__*/_createTextVNode("暂不实名")
const _hoisted_59 = /*#__PURE__*/_createTextVNode("我要实名")
const _hoisted_60 = { class: "notFollow" }
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "温馨提示", -1))
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content" }, "尊敬的用户，查看电话需要先对此采购进行报价，尚未报价，请尽快进行报价！", -1))
const _hoisted_63 = { class: "btn" }
const _hoisted_64 = /*#__PURE__*/_createTextVNode("暂不报价")
const _hoisted_65 = /*#__PURE__*/_createTextVNode("我要报价")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ShopHeader = _resolveComponent("ShopHeader")!
  const _component_VanImage = _resolveComponent("VanImage")!
  const _component_VanIcon = _resolveComponent("VanIcon")!
  const _component_VanTag = _resolveComponent("VanTag")!
  const _component_VipTag = _resolveComponent("VipTag")!
  const _component_ListItemAd = _resolveComponent("ListItemAd")!
  const _component_VanList = _resolveComponent("VanList")!
  const _component_VanButton = _resolveComponent("VanButton")!
  const _component_RestrictDialog = _resolveComponent("RestrictDialog")!
  const _component_vanButton = _resolveComponent("vanButton")!
  const _component_VanPopup = _resolveComponent("VanPopup")!

  return (Object.keys(_ctx.detail).length != 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_ShopHeader, {
            detail: _ctx.detail,
            type: "PurchaseDetail"
          }, null, 8, ["detail"])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.detail.title), 1)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.detail.profile), 1)
          ]),
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.detail.payTerm === 2 ? '到货价' : '上车价'), 1)
          ]),
          _createElementVNode("div", _hoisted_13, [
            _hoisted_14,
            _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.detail.createTime), 1)
          ]),
          _createElementVNode("div", _hoisted_16, [
            _hoisted_17,
            _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.detail.expectAddress.join(',')) + "(信息由个人和企业提供，请自行鉴别真实性)", 1)
          ])
        ]),
        _hoisted_19,
        _createVNode(_component_VanList, {
          class: "list",
          listLoading: _ctx.loading,
          "onUpdate:listLoading": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.loading) = $event)),
          onLoad: _ctx.getList,
          "immediate-check": false,
          finished: _ctx.finished,
          "finished-text": ""
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (item, index) => {
              return (_openBlock(), _createBlock(_component_ListItemAd, {
                key: `supply${index}`
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", {
                    class: "list-item",
                    onClick: ($event: any) => (this.$router.push({name: "SupplyDetail", query: {id: item.id}}))
                  }, [
                    _createElementVNode("div", _hoisted_21, [
                      _withDirectives(_createElementVNode("div", _hoisted_22, [
                        _createVNode(_component_VanImage, {
                          src: require("@/assets/img/supply_top_tag.png")
                        }, null, 8, ["src"])
                      ], 512), [
                        [_vShow, item.supplyTop]
                      ]),
                      _createElementVNode("div", _hoisted_23, [
                        _createVNode(_component_VanImage, {
                          src: item.photos ? item.photos[0] : "",
                          radius: "4",
                          style: {"width":"100%","height":"100%"}
                        }, null, 8, ["src"]),
                        (item.video.length)
                          ? (_openBlock(), _createBlock(_component_VanIcon, {
                              key: 0,
                              class: "play",
                              name: "play-circle-o",
                              size: "40",
                              color: "#FFF"
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_24, [
                        _createElementVNode("div", _hoisted_25, [
                          _createElementVNode("div", _hoisted_26, _toDisplayString(item.title), 1),
                          _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.time2Stamp(item.refreshTime)), 1)
                        ]),
                        _createElementVNode("div", _hoisted_28, [
                          (item.minPrice != 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                                _createElementVNode("span", null, _toDisplayString(Number(item.minPrice).toFixed(2)) + " / " + _toDisplayString(item.unit), 1)
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_30, _hoisted_32)),
                          _createElementVNode("div", {
                            class: "similar",
                            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.likemore()), ["stop"]))
                          }, "类似供应")
                        ]),
                        _createElementVNode("div", _hoisted_33, [
                          _withDirectives(_createVNode(_component_VanTag, {
                            size: "small",
                            plain: "",
                            type: "success"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_34
                            ]),
                            _: 2
                          }, 1536), [
                            [_vShow, item.userCertification.reassureRank]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_35, [
                          _createVNode(_component_VipTag, {
                            type: item.userCertification.vipRank,
                            year: item.year
                          }, null, 8, ["type", "year"]),
                          _withDirectives(_createVNode(_component_VanTag, {
                            size: "small",
                            plain: "",
                            type: "primary"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_36
                            ]),
                            _: 2
                          }, 1536), [
                            [_vShow, item.userCertification.hasIdCard]
                          ]),
                          _withDirectives(_createVNode(_component_VanTag, {
                            size: "small",
                            plain: "",
                            color: "#6775D2"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_37
                            ]),
                            _: 2
                          }, 1536), [
                            [_vShow, item.userCertification.hasBusinessLicense]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_38, [
                          _createElementVNode("div", _hoisted_39, _toDisplayString(item.address), 1),
                          _createElementVNode("div", _hoisted_40, _toDisplayString(_ctx.distance(item.location)), 1)
                        ])
                      ])
                    ])
                  ], 8, _hoisted_20)
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        }, 8, ["listLoading", "onLoad", "finished"]),
        _createElementVNode("div", _hoisted_41, [
          _createElementVNode("a", {
            style: {"color":"#576B95"},
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.more()))
          }, "查看更多求购")
        ]),
        _createElementVNode("div", _hoisted_42, [
          _createVNode(_component_VanButton, {
            block: "",
            color: "#33AC9C",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.toQuotedPrice())),
            icon: "description"
          }, {
            default: _withCtx(() => [
              _hoisted_43
            ]),
            _: 1
          }),
          _createVNode(_component_VanButton, {
            block: "",
            color: "#E94632",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showRestrictDialog())),
            icon: "phone"
          }, {
            default: _withCtx(() => [
              _hoisted_44
            ]),
            _: 1
          })
        ]),
        _createVNode(_component_RestrictDialog, {
          modelValue: _ctx.restrictShow,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.restrictShow) = $event)),
          code: _ctx.restrictCode,
          type: "single"
        }, null, 8, ["modelValue", "code"]),
        _createVNode(_component_VanPopup, {
          class: "callDialog",
          show: _ctx.isShowTel,
          "onUpdate:show": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.isShowTel) = $event))
        }, {
          default: _withCtx(() => [
            _hoisted_45,
            _createElementVNode("div", _hoisted_46, "是否拨打 " + _toDisplayString(_ctx.tel), 1),
            _createElementVNode("div", _hoisted_47, [
              _createVNode(_component_vanButton, {
                round: "",
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.cancel())),
                icon: "close",
                size: "mini"
              }, {
                default: _withCtx(() => [
                  _hoisted_48
                ]),
                _: 1
              }),
              _createVNode(_component_vanButton, {
                round: "",
                onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.call())),
                icon: "phone",
                color: "#33AC9C",
                size: "mini"
              }, {
                default: _withCtx(() => [
                  _hoisted_49
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }, 8, ["show"]),
        _createVNode(_component_VanPopup, {
          show: _ctx.isNotFollow,
          "onUpdate:show": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.isNotFollow) = $event)),
          style: {"width":"80vw","border-radius":"4px"}
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_50, [
              _hoisted_51,
              _hoisted_52,
              _createVNode(_component_VanImage, {
                src: "https://mdd-static.oss-cn-hangzhou.aliyuncs.com/wechat/gzh.jpg",
                style: {"width":"100%"},
                radius: "4"
              }),
              _hoisted_53
            ])
          ]),
          _: 1
        }, 8, ["show"]),
        _createVNode(_component_VanPopup, {
          show: _ctx.isRealName,
          "onUpdate:show": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.isRealName) = $event)),
          style: {"width":"80vw","border-radius":"4px"}
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_54, [
              _hoisted_55,
              _hoisted_56,
              _createElementVNode("div", _hoisted_57, [
                _createVNode(_component_vanButton, {
                  round: "",
                  onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.cancelRealName())),
                  size: "mini"
                }, {
                  default: _withCtx(() => [
                    _hoisted_58
                  ]),
                  _: 1
                }),
                _createVNode(_component_vanButton, {
                  round: "",
                  onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.gotoRealName())),
                  style: {"border":"solid 1px #f00","margin-left":"20px"},
                  type: "danger",
                  size: "mini"
                }, {
                  default: _withCtx(() => [
                    _hoisted_59
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _: 1
        }, 8, ["show"]),
        _createVNode(_component_VanPopup, {
          show: _ctx.IsBaojia,
          "onUpdate:show": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.IsBaojia) = $event)),
          style: {"width":"80vw","border-radius":"4px"}
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_60, [
              _hoisted_61,
              _hoisted_62,
              _createElementVNode("div", _hoisted_63, [
                _createVNode(_component_vanButton, {
                  round: "",
                  onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.cancelBaoJia())),
                  size: "mini"
                }, {
                  default: _withCtx(() => [
                    _hoisted_64
                  ]),
                  _: 1
                }),
                _createVNode(_component_vanButton, {
                  round: "",
                  onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.gotoBaoJia())),
                  type: "info",
                  style: {"border":"solid 1px #ddd","margin-left":"20px"},
                  size: "mini"
                }, {
                  default: _withCtx(() => [
                    _hoisted_65
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _: 1
        }, 8, ["show"])
      ]))
    : _createCommentVNode("", true)
}